$(function () {
    // reserve payment page の支払方法の初期開閉
    if($('#ReserveConfirmPayment')){
        let paymentMethod = $('#ReserveConfirmPayment input[name="payment_method"]').val()
        if (paymentMethod === 'credit') {
            $('#ReserveConfirmPayment .credit').addClass('open');
        } else if (paymentMethod === 'registered_credit') {
            $('#ReserveConfirmPayment .registered_credit').addClass('open');
        } else if (paymentMethod === 'convenience') {
            $('#ReserveConfirmPayment .convenience').addClass('open');
        }
    }
    $('#ReserveConfirmPayment .credit .header').click(() => {
        if($('#ReserveConfirmPayment .credit').hasClass('open')) {
            $('#ReserveConfirmPayment .credit').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('')
        } else {
            $('#ReserveConfirmPayment .credit').addClass('open');
            $('#ReserveConfirmPayment .registered_credit').removeClass('open');
            $('#ReserveConfirmPayment .convenience').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('credit')
        }
        monitoringPayment();
    })
    $('#ReserveConfirmPayment .registered_credit .header').click(() => {
        if($('#ReserveConfirmPayment .registered_credit').hasClass('open')) {
            $('#ReserveConfirmPayment .registered_credit').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('')
        } else {
            $('#ReserveConfirmPayment .registered_credit').addClass('open');
            $('#ReserveConfirmPayment .credit').removeClass('open');
            $('#ReserveConfirmPayment .convenience').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('registered_credit')
        }
        monitoringPayment();
    })
    $('#ReserveConfirmPayment .convenience .header').click(() => {
        if($('#ReserveConfirmPayment .convenience').hasClass('open')) {
            $('#ReserveConfirmPayment .convenience').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('')
        } else {
            $('#ReserveConfirmPayment .convenience').addClass('open');
            $('#ReserveConfirmPayment .credit').removeClass('open');
            $('#ReserveConfirmPayment .registered_credit').removeClass('open');
            $('#ReserveConfirmPayment input[name="payment_method"]').val('convenience')
        }
        monitoringPayment();
    })

    $('#ReserveConfirmPayment .backBtn').click(() => {
        $('#reserve_form input[type="button"]').prop('disabled', true)
        $('#reserve_form .backBtn').addClass('disabled')
        let action = $('#reserve_form').attr('action');
        action = action.replace("confirm_final", "confirm");
        $('#reserve_form').append('<input type="hidden" name="back">');
        $('#reserve_form').attr('action', action);
        document.getElementById("reserve_form").submit();
    })

    $('#ReserveConfirmPayment input').on('input', () => {
        monitoringPayment();
    })
    $('#ReserveConfirmPayment select').change(() => {
        monitoringPayment();
    })
    monitoringPayment();
});

// 同意ボタンのチェック有無で送信ボタンを有効にする
function monitoringPayment () {
    if ($('#ReserveConfirmPayment input[name="payment_method"]').val() === '') {
        $('#ReserveConfirmPayment input[type="button"]').prop('disabled', true);
    } else if ($('#ReserveConfirmPayment input[name="payment_method"]').val() === 'credit') {
        const cardno = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cardno]"]').val();
        const holdername = $('#ReserveConfirmPayment input[name="fitness_reserve_header[holdername]"]').val();
        const expire_month = $('#ReserveConfirmPayment select[name="fitness_reserve_header[expire_month]"]').val();
        const expire_year = $('#ReserveConfirmPayment select[name="fitness_reserve_header[expire_year]"]').val();
        const securitycode = $('#ReserveConfirmPayment input[name="fitness_reserve_header[securitycode]"]').val();
        if(cardno && holdername && expire_month && expire_year && securitycode) {
            $('#ReserveConfirmPayment input[type="button"]').prop('disabled', false);
        } else {
            $('#ReserveConfirmPayment input[type="button"]').prop('disabled', true);
        }
    } else if ($('#ReserveConfirmPayment input[name="payment_method"]').val() === 'registered_credit') {
        $('#ReserveConfirmPayment input[type="button"]').prop('disabled', false);
    } else if ($('#ReserveConfirmPayment input[name="payment_method"]').val() === 'convenience') {
        const cvs_code = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_code]"]:checked').val();
        const cvs_last_name = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_last_name]').val();
        const cvs_first_name = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_first_name]"]').val();
        const cvs_last_name_kana = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_last_name_kana]"]').val();
        const cvs_first_name_kana = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_first_name_kana]"]').val();
        const cvs_telephone_no = $('#ReserveConfirmPayment input[name="fitness_reserve_header[cvs_telephone_no]"]').val();
        const regexp = new RegExp(/^[-]?([0-9]\d*|0)$/);

        if (cvs_telephone_no && !regexp.test(cvs_telephone_no)){
            $('#ReserveConfirmPayment .input-area-tel .alert_message').text('半角数字のみ入力してください')
        } else {
            $('#ReserveConfirmPayment .input-area-tel .alert_message').text('')
        }

        if(cvs_code && cvs_last_name && cvs_first_name && cvs_last_name_kana && cvs_first_name_kana && cvs_telephone_no && regexp.test(cvs_telephone_no)) {
            $('#ReserveConfirmPayment input[type="button"]').prop('disabled', false);
        } else {
            $('#ReserveConfirmPayment input[type="button"]').prop('disabled', true);
        }
    }
}